import { render, staticRenderFns } from "./CandidateTextMenu.vue?vue&type=template&id=10c42db2&lang=pug"
import script from "./CandidateTextMenu.vue?vue&type=script&lang=js"
export * from "./CandidateTextMenu.vue?vue&type=script&lang=js"
import style0 from "./CandidateTextMenu.vue?vue&type=style&index=0&id=10c42db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports